const toggleSwitch = document.getElementById("toggle");
const toggleSwitch_mobile = document.getElementById("toggle_mobile");
const toggleSwitch_mobile2 = document.getElementById("toggle_mobile2");

function handleToggleChange(isChecked) {
  console.log("isChecked", isChecked);
  const switchButtons = document.querySelectorAll(".switch_btn");
  switchButtons.forEach((button) => {
    button.classList.toggle("checked", isChecked);
  });
  const paramItems = document.querySelectorAll(".c_param_item");
  paramItems.forEach((item) => {
    if (window.innerWidth < 1024) {
      const paramDescItems = item.querySelectorAll(".param_desc_item");
      let firstContext;
      let secondContext;
      paramDescItems.forEach((itemDesc) => {
        if (itemDesc.style.order === "1" || itemDesc.style.order === 1) {
          firstContext = itemDesc.querySelector(".param_title").textContent;
        }
        if (itemDesc.style.order === "2" || itemDesc.style.order === 2) {
          secondContext = itemDesc.querySelector(".param_title").textContent;
        }
      });

      if (isChecked && firstContext === secondContext) {
        item.style.display = "none";
      } else {
        item.style.display = "grid";
      }
    } else {
      const paramTitles = item.querySelectorAll(".param_title");
      const firstTitle = paramTitles[0]?.textContent;
      const allSame = Array.from(paramTitles).every(
        (title) => title.textContent === firstTitle
      );

      if (isChecked && allSame) {
        item.style.display = "none";
      } else {
        item.style.display = "grid";
      }
    }
  });
}

document.querySelectorAll(".switch_btn").forEach((switchBtn) => {
  switchBtn.addEventListener("change", function () {
    handleToggleChange(this.checked);
  });
});

// toggleSwitch.addEventListener('change', function () {
//   handleToggleChange(this.checked);
// });

// toggleSwitch_mobile.addEventListener('change', function () {
//   handleToggleChange(this.checked);
// });

// toggleSwitch_mobile2.addEventListener('change', function () {
//   handleToggleChange(this.checked);
// });

// 防抖函数
function debounce(func, delay) {
  let timeoutId;
  return function (...arguments) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, arguments);
    }, delay);
  };
}

let compareHeaderFun = false;
let compareHeaderFun_time = 0;

const updateCompareHeader = () => {
  const compare_context_header = document.querySelector(
    ".compare_context_header"
  );
  const compareHeader = document.querySelector(".compare_products_header");
  const compareHeader_scoller = document.querySelector(".scoller_header");
  const compare_products_footer = document.querySelector(
    ".compare_products_footer"
  );
  const compare_switch = document.querySelector(".compare_switch");
  const compare_mobile_switch = document.querySelector(
    ".compare_mobile_switch"
  );
  const productImages = compareHeader.querySelectorAll(".product_image");
  const product_description = compareHeader.querySelectorAll(
    ".product_description p"
  );
  const product_link = compareHeader.querySelectorAll(".product_link a");
  const product_price = compareHeader.querySelectorAll(".product_price");

  if (
    compare_context_header.getBoundingClientRect().top <= 150 &&
    !compareHeaderFun
  ) {
    compareHeaderFun = true;
    clearTimeout(compareHeaderFun_time);
    compareHeaderFun_time = setTimeout(() => {
      compareHeaderFun = false;
    }, 510);
    // compareHeader.classList.add('box_shadow');
    // compare_switch.style.marginTop = '0';
    // productImages.forEach(image => {
    //   image.style.height = '0';
    // });
    // product_price.forEach(price => {
    //   price.style.display = 'none';
    // });
    // product_description.forEach(description => {
    //   description.style.display = 'none';
    // });
    // product_link.forEach(link => {
    //   link.classList.add('simple_style');
    // });
    // if (window.innerWidth < 1024) {
    //   compare_mobile_switch.style.display = 'flex';
    //   document.querySelector('.mobile_switch').style.display = 'none';
    // }
    compareHeader_scoller.style.display = "block";
    setTimeout(() => {
      compareHeader_scoller.style.transform = "translateY(0px)";
    }, 100);
  }
  if (
    compare_context_header.getBoundingClientRect().top > 150 &&
    compareHeaderFun
  ) {
    // compareHeader.classList.remove('box_shadow');
    // compare_switch.style.marginTop = '48px';
    // productImages.forEach(image => {
    //   image.style.height = this.window.innerWidth < 650 ? '82px' : '182px';
    // });
    // product_price.forEach(price => {
    //   price.style.display = 'block';
    // });
    // product_description.forEach(description => {
    //   description.style.display = 'block';
    // });
    // product_link.forEach(link => {
    //   link.classList.remove('simple_style');
    // });
    // compareHeader_scoller.style.transform = 'translateY(-100px)'
    // if (window.innerWidth < 1024) {
    //   compare_mobile_switch.style.display = 'none';
    //   document.querySelector('.mobile_switch').style.display = 'block';
    // }
    compareHeader_scoller.style.transform =
      window.innerWidth < 1024 ? "translateY(-200px)" : "translateY(-100px)";
    setTimeout(() => {
      compareHeader_scoller.style.display = "none";
    }, 600);
  }
  let lastScrollTop = 0;
  const isScrollingUp = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingUp = scrollTop < lastScrollTop;
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    return scrollingUp;
  };

  if (
    compare_products_footer.getBoundingClientRect().top <= 100 &&
    !isScrollingUp()
  ) {
    compareHeader_scoller.style.transform =
      window.innerWidth < 1024 ? "translateY(-200px)" : "translateY(-100px)";
    setTimeout(() => {
      compareHeader_scoller.style.display = "none";
    }, 600);
  }
  // if (compare_products_footer.getBoundingClientRect().top > 48) {
  //   compareHeader_scoller.style.display = 'block';
  //   setTimeout(() => {
  //     compareHeader_scoller.style.transform = 'translateY(0px)'
  //   }, 100)
  // }
};
const debouncedUpdateCompareHeader = debounce(updateCompareHeader, 0);

window.addEventListener("scroll", function () {
  debouncedUpdateCompareHeader();
});

function getProductSelectHeight(menu) {
  const previousHeight = menu.style.height;
  menu.style.height = "auto";
  const height = menu.scrollHeight;
  menu.style.height = previousHeight || "0px";
  menu.offsetHeight;
  return height;
}

function openProductSelect(menu) {
  menu.style.height = getProductSelectHeight(menu) + "px";
  menu.style.border = "1px solid #E6E6E6";
}

function closeProductSelect(menu) {
  menu.style.height = "0";
  menu.style.border = "0px solid #E6E6E6";
}

// 下拉框
document.querySelectorAll(".select_trigger").forEach((trigger) => {
  trigger.addEventListener("click", function () {
    const menu = this.nextElementSibling;
    const willOpen = !this.classList.contains("open");
    this.classList.toggle("open", willOpen);
    if (willOpen) {
      openProductSelect(menu);
    } else {
      closeProductSelect(menu);
    }
  });
});

document.addEventListener("click", function (event) {
  const isClickInside =
    event.target.closest(".select_trigger") ||
    event.target.closest(".select_option-warp");
  if (!isClickInside) {
    document.querySelectorAll(".select_trigger").forEach((trigger) => {
      trigger.classList.remove("open");
      closeProductSelect(trigger.nextElementSibling);
    });
  }
});

$(".option_item").on("click", function () {
  const selectedProductName = $(this).data("productname");
  const selectSequence = $(this).data("sequence");
  if ($(this).hasClass("choosed")) {
    return;
  } else if ($(this).hasClass("selected")) {
    // $(this).parent().css({'height': '0', 'border': '0px solid #E6E6E6'});
    // $(this).parent().prev().removeClass('open');
    var items = $(
      `.option_item[data-productname="${selectedProductName}"][data-sequence="${selectSequence}"]`
    );
    items.each(function () {
      $(this).parent().css({ height: "0", border: "0px solid #E6E6E6" });
      $(this).parent().prev().removeClass("open");
    });
  } else {
    var items = $(
      `.option_item[data-productname="${selectedProductName}"][data-sequence="${selectSequence}"]`
    );
    items.each(function () {
      $(this).parent().css({ height: "0", border: "0px solid #E6E6E6" });
      $(this).parent().prev().removeClass("open");
      $(this).parent().css({ height: "0", border: "0px solid #E6E6E6" });
      $(this).parent().prev().removeClass("open");
      $(this).siblings().removeClass("selected");
      $(this).addClass("selected");
      $(this).parent().prev().find("span").html($(this).text());
    });

    const dataIndex = $(this).data("index");
    const optionorder = $(this).data("optionorder");
    if (optionorder == "two") {
      $(`.option_item[data-optionorder="one"][data-index="${dataIndex}"]`)
        .addClass("choosed")
        .siblings()
        .removeClass("choosed");
    }
    if (optionorder == "one") {
      $(`.option_item[data-optionorder="two"][data-index="${dataIndex}"]`)
        .addClass("choosed")
        .siblings()
        .removeClass("choosed");
    }
    const selectedIndex = dataIndex;
    const choosedIndex = $(this).siblings(".choosed").data("index");

    $(".compare_product_list")
      .children()
      .hide()
      .css("order", "3")
      .each(function (index) {
        // if (index == selectedIndex - 1 || index == choosedIndex - 1) {
        //   $(this).css("display", 'flex');
        // }
        const product_mobile_details = $(".product_mobile_details");
        if (index == selectedIndex - 1 && optionorder == "one") {
          $(this).css({ order: "1", display: "flex" });
          console.log("Selected index:", selectedIndex);
          $(product_mobile_details[selectedIndex - 1]).css({
            order: "1",
            display: "flex",
          });
        }
        if (index == choosedIndex - 1 && optionorder == "one") {
          $(this).css({ order: "2", display: "flex" });
          $(product_mobile_details[choosedIndex - 1]).css({
            order: "2",
            display: "flex",
          });
        }
        if (index == selectedIndex - 1 && optionorder == "two") {
          $(this).css({ order: "2", display: "flex" });
          $(product_mobile_details[selectedIndex - 1]).css({
            order: "2",
            display: "flex",
          });
        }
        if (index == choosedIndex - 1 && optionorder == "two") {
          $(this).css({ order: "1", display: "flex" });
          $(product_mobile_details[choosedIndex - 1]).css({
            order: "1",
            display: "flex",
          });
        }
      });
    $(".param_json").each(function () {
      $(this)
        .children()
        .hide()
        .css("order", "3")
        .each(function (index) {
          if (index == selectedIndex - 1 && optionorder == "one") {
            $(this).css({ order: "1", display: "flex" });
          }
          if (index == choosedIndex - 1 && optionorder == "one") {
            $(this).css({ order: "2", display: "flex" });
          }
          if (index == selectedIndex - 1 && optionorder == "two") {
            $(this).css({ order: "2", display: "flex" });
          }
          if (index == choosedIndex - 1 && optionorder == "two") {
            $(this).css({ order: "1", display: "flex" });
          }
        });
    });
  }
});
